import {useKeycloak} from '@react-keycloak/web';
import {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import {findPatientByMyself} from 'services/PatientService';

export const useHealthInfo = () => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();
  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const isAuthenticated = keycloak.authenticated;
  const [patient, setPatient] = useState();

  useEffect(() => {
    if (isAuthenticated) {
      findPatientByMyself(headers).then((res) => setPatient(res.data));
    }
  }, [isAuthenticated]);

  return {patient};
};
